export default __webpack_public_path__ + "static/media/DW2.75bf5e25.png";